import { createSelector } from '@reduxjs/toolkit'

import { ApplicationState } from 'redux/Stores/types'
import { SnackbarType } from 'redux/reducers/Snackbar'

export const selectSnackbar = createSelector(
  [
    (state: ApplicationState): SnackbarType => state.SnackbarStore
  ],
  (snackbar) => snackbar
)

export const selectSnackbarOpen = createSelector(
  [selectSnackbar],
  (snackbar) => snackbar.open
)
